import { Box, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
// TODO: This needs to be moved / Refactored
import { useDesktopNavigation } from 'app/domains/common-ui/components/PageLayout/components/DesktopNavigation';
import { useMobileNavigation } from 'app/domains/common-ui/components/PageLayout/components/MobileNavigation';
import useMobile from '../hooks/useMobile';
import { TopbarContainer } from './styled';
export function Topbar(props) {
    const { breadcrumbs, actions } = props;
    const isMobile = useMobile();
    const { open } = useMobileNavigation();
    const { setMinimized, minimized } = useDesktopNavigation();
    const handleMenuToggle = () => {
        if (isMobile) {
            open();
        }
        else {
            setMinimized(!minimized);
        }
    };
    return (<TopbarContainer>
      <Box alignItems="center" mr="md">
        <IconButton type="button" appearance="ghost" size="xs" onClick={handleMenuToggle}>
          <Falcon icon="sidebar"/>
        </IconButton>
      </Box>

      {breadcrumbs}

      {actions && (<Box ml="auto" style={{ flexShrink: 0 }} gap="md">
          {actions}
        </Box>)}
    </TopbarContainer>);
}
